import { Any } from 'json2typescript';

export class TechModalDialogModel {
  title?: String;
  icon?: String;
  content?: Any;
  footer?: Any;
}
